import React from 'react';

export const QrCodeIcon = ({ fontSize }) => <i className="fa fa-qrcode" style={{ fontSize }} />;
